var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.515,
    height: 18.515,
    viewBox: "0 0 18.515 18.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#727275",
    d: "M7.361 5.738h5.524v1.85H7.361V13.3H5.5V7.589H0V5.738h5.5V0h1.861z",
    transform: "translate(0 0) translate(0 9.111) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconclose);
export default __webpack_public_path__ + "static/media/iconclose.df588d3aabc27cfe358c5e1bbca609bc.svg";
export { ForwardRef as ReactComponent };